import { EDestinationType } from '../../interfaces';

export enum EShopSystem {
  ABSENT = 'absent',
  SHOPIFY = 'shopify',
  SHOPWARE_5 = 'shopware5',
  SHOPWARE_6 = 'shopware6',
}

/**
 * Shopify market Data Receieved from the shopify API
 */
export type TMarketConfigData = {
  is_primary: boolean;
  md: string;
  mh: string;
  mid: string;
  ml: string;
  mr: string[];
};

export type IShopConfig = {
  getDestinations: () => TDestinationSetting[];
  isPerDestinationConsentActive: () => boolean;
  shopConfigData?: ShopConfigData;
};

export type TExternalSourcesConfig = {
  /**
   * The market ID that the external source is assigned to
   */
  assignedMarketId?: string;
  /**
   * The ID of the external source
   */
  id: number;
};

export type ShopConfigData = {
  active: boolean;
  config: TSourceConfigSettings;
  customEvents?: any[];
  destinations: TDestinationSetting[];
  /**
   * The external sources config
   */
  ExternalSourcesConfig?: TExternalSourcesConfig[];
  shopifyMarkets?: TMarketConfigData[];
  sourceType: EShopSystem;
  uid: string;
};

export type TSourceConfigSettings = {
  [key: string]: any;
  cart_attributes_enabled?: boolean;
  is_test?: boolean;
  isDebug?: boolean;
  line_items_enabled?: boolean;
  perDestinationConsentActive?: boolean;
  script_tag_worker_retry_enabled: boolean;
  script_tag_wtag_retry_enabled: boolean;
  shpy_cartTokenSyncDisabled?: boolean;
  shpy_checkoutTokenSyncDisabled?: boolean;
  wgs_custom_domain?: string;
};

export type TDestinationBusinessLogicSettings = any;

export type TDestinationSetting = {
  active: boolean;
  businessLogic?: TDestinationBusinessLogicSettings;
  creds?: TDestinationCredentials;
  /**
   * ID is a UUID(v4) string
   */
  id: string;
  type: EDestinationType;
};

/**
 * Defines how products should be identified in the catalog
 */
export enum ECatalogItemIdentifierType {
  PRODUCT_ID = 'pid',
  SKU = 'sku',
  VARIANT_ID = 'vid',
}

/**
 * General credentials for all destinations
 */
export type TGeneralCredentials = {
  /**
   * Specifies which product identifier to use when matching products with the catalog
   */
  active?: boolean;
  /**
   * Flag to indicate if the destination is allowed for all markets
   */
  all_markets_selected?: boolean;
  catalog_item_identifier_type: ECatalogItemIdentifierType;
  /**
   * Conversion resource map
   */
  conversionResourceMap?: Record<string, string>;
  /**
   * Google Tag ID
   */
  googleTagId?: string;
  /**
   * Market resource map
   */
  marketResourceMap?: Record<string, Record<string, string>>;

  /**
   * List of market IDs that the destination supports
   */
  supported_market_ids?: string[];
};

export type TDestinationCredentials = Record<string, any> & TGeneralCredentials;
